import { render, staticRenderFns } from "./newAccountModal.vue?vue&type=template&id=53676ed4&scoped=true&"
import script from "./newAccountModal.vue?vue&type=script&lang=js&"
export * from "./newAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53676ed4",
  null
  
)

export default component.exports